import AgencyGroupManagement from '.'
import { checkProdSite } from '../../helpers/checkProdSite'
import { PageRoute } from '../../routes/routerInterface'

const AgencyGroupManagementRoutes: PageRoute[] = [
  {
    path: '/agency-group-management',
    element: AgencyGroupManagement,
    isProtected: true,
    permission: checkProdSite(true, 'Admin'),
  },
]

export default AgencyGroupManagementRoutes
